import { each } from '@/utils/assist'
export const state = () => ({
  data: {
  },
  history: {
  },
  districtDetailsAddress: '',
  isNeedTableware: false, // 是否需要餐具回收
  isBrandStoreOne: false, // 是否品牌只有一家门店使用该门店号码
  isSendOrder: false,
  oprInfo: {}, // 运营商数据
  brandInfo: {}, // 品牌数据
  isChoose: false,
  storeList: [],
  sendType: 1,
  longitude: 0, // 经度
  latitude: 0, // 纬度
  reserveDate: null, // 时间
  storeId: null, // 门店ID
  storeDateList: [], // 门店时间列表
  vipPhone: '',
  phone: null,
  countryAreaCode:'',
  countryCode:'',
  name: '',
  userArea:null,
  storeArea:null,
  address: null,
  consigneeAddress: '', //ccfs 地址
  detailAddress: '', // ccfs 补全地址
  sex: 0, // 性别，1男 2女 0未知
  historyAddressList: [],
  lastConsigneeAddress: [], // 根据业务类型保存的上一次下单历史地址
  selfTakeaddress: '', //自取地址
  provinceId:0, // 省份Id
  provinceName: '', //省份名称
	cityId:0, //  城市Id
	districtId: 0 ,// 区域Id
	districtName: 0 ,// 区域名称
  storeListLoading: false,
  pageNow:1, //用于门店列表分页
  pages:0, //用于门店列表分页
  page:0, //用于门店列表分页
  isPre: false, //用于门店列表分页
  isNext: false, //用于门店列表分页
  cityName: '', //城市名称 用于搜索地址
  orderAmend: { // 改单对象
    orderData: {},
    isAmend: false, // 是否可以改单
    isStore: false, // 是否可以更改门店
    isProducts: false, // 是否可以更改餐品
    isOnlinePay: false, // 是否是线上支付
    isBase: false, // 是否可以更改基础信息（姓名、 电话、 备注、送餐地址）
  },
  tencentMapKey:'',
  oldAddressData:{},
  newAmend: false, // 改单的话是否走新逻辑
  orderId: false, // 记录改单的订单id
  finishAmendMode: false,
  orderType: 0,
  sendTime:'',
  storeId:0
});
export const mutations = {
  update(state,data){
    each(data, (value, key) => {
      state[key] = value
    })
  },
};
export const actions = {
  update({commit}, data) {
    commit('update', data);
  }
};



// WEBPACK FOOTER //
// ./store/booking/user.js